import type { FaireProductEntity } from "../../entity_types/product";

export const p_8p3sqevg2s: FaireProductEntity = {
  token: "p_8p3sqevg2s",
  type: "product",
  name: "Detox kit | spa gift box | cleansing | purifying",
  brandToken: "b_m3n7j6u3h2",
  brandName: "Salt + Soul Skincare",
  imageUrl:
    "https://cdn.faire.com/fastly/d48e3e1808584e2d64b53100f5870655c81779127b22df1a0e8abc4176021883.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c454389a891e449c343fe5463afeb2fa29e49b202e2bcafc1cbb38a7a984de0a.jpeg",
    "https://cdn.faire.com/fastly/7be5c84b6204ca73a1a090dbf32f90472e9d0d923a3bd03f5d6bb0a357e4089c.jpeg",
    "https://cdn.faire.com/fastly/019bae3167846a871ccdc2ad64c797a1a78f42414bff3fcf367354d2e1b31f05.jpeg",
    "https://cdn.faire.com/fastly/975bcec036a0abd323912476ea9681ab5380ecb1c32a18443c312f4d7a62c35b.jpeg",
    "https://cdn.faire.com/fastly/ebde4cb80d240f7d1fd89f8942169b9397258adda42e64410d1300eb835f40af.jpeg",
    "https://cdn.faire.com/fastly/0de59f5638aecfee0f7d4b0e70d6cdc53fc0b56609f487bcb80d84ac3652e901.jpeg",
    "https://cdn.faire.com/fastly/3393d5a50ccc86f75fcf4f51f41d12fc27608454a8beda221aefe8af190427b4.jpeg",
    "https://cdn.faire.com/fastly/f6217d9c199f7dc7e374c926aa41f0602b26f840574dfe0c2702d308a6060042.jpeg",
    "https://cdn.faire.com/fastly/ea4de6f379b8cb74f38d0ffdbbe7ba7f7f9d316f67eebc2a3815a8b9e40638e9.jpeg",
  ],
  priceDollars: 35,
  description:
    "Detox purifying self care box. Our ready to gift detox set will leave you feeling pure + fresh. Clear negative energies and scrub away your worries!\n\n𝐁𝐞𝐧𝐞𝐟𝐢𝐭𝐬\n• Anti aging serum to reduce fine lines + wrinkles. Smooth, balance, tone, & awaken your intuition.\n• Detoxifying scrub helps to clear dead, dry skin & encourage cell turnover. Magnesium + Epsom salts help draw out impurities while nourishing with oils.\n• Purifying mask draws out impurities from the face, tightens pores, eliminates oil, + soothe with peppermint/lavender.\n• White sage bundle with palo santo + green calcite helps to clear negative energies, reduce stress + anxiety, help connect you to the universe + spirit guides.\n\n𝐎𝐮𝐫 𝐛𝐨𝐱 𝐢𝐧𝐜𝐥𝐮𝐝𝐞𝐬:\n• Hand wrapped white sage bundle, 1 Palo santo stick, 1 green calcite crystal\n• 8 oz Detox all natural body scrub\n• 15 ML organic Anti aging facial serum\n• 2oz purifying Dead Sea mud + bamboo activated charcoal mask\n• Ramie body mitt\n• Natural wood pinch pot with scoop\n• Silicone applicator",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:47.202Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
